module.exports = __webpack_public_path__ + "static/media/brinquedo11.536ef950.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/brinquedo11.jpg
// module id = 67
// module chunks = 0